import React, { useEffect, useState, useRef } from "react";
import { ENUMS } from "../utils/Enums";
import { listen } from "../hooks/Listener";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { showError, showMessage } from "../ui/Message";
import Input from "../ui/Input";

export default function CustomerFilterSelect(props) {

    const { controller = "", route = "", callback = () => {} } = props;
    const row_key = "value";
    const [search, setSearch] = useState("");
    const [align, setAlign] = useState("auto");

    const data = ENUMS.CUSTOMER_FILTERS.filter(item => item.value > 0 && (item.label.toUpperCase().includes(search.toUpperCase()) || item.value == search ));


    const srch = useRef(null)
    const [selected, setSelected] = useState(data[0]);

    useEffect(() => {
        if(srch?.current){
            srch.current.blur(); 
        }
    }, [selected])

    useEffect(() => {
        if(data?.length > 0){
            setSelected(data[0])
        } else {
            setSelected({})
        }
    }, [data.length])
    

    const columns = [
    
        { key: "value", title: <>#</>, align: "left", grow: true, width: 10, render : (e, f) => {
            return(<span style={{"color" : (f.active) ? "var(--text)" : "var(--text-dim)"}}>{e}</span>)
        } },
        { key: "label", title: <>Search: <strong style={{"color" : "var(--text)"}}>&nbsp;<Input ref={srch} onClick={() => setSelected()} controlled style={{"textAlign" : "left", "paddingLeft" : "5px", "height" : "25px", "width" : "calc(100% - 50px)"}} cell edit={true} value={search} /></strong></>, align: "left", grow: true, width: 300, render : (e, f) => {
            return(<span style={{"color" : (f.active) ? "var(--text)" : "var(--text-dim)"}}>{e}</span>)
        } },
    ]

    const nav = [
        {
            key: KBD.ANY, text: "Total", action: (e) => {

                if (e.key === KBD.ESCAPE.key) {
                    callback(false);
                    return;
                }

                if (e.key === KBD.ARROW_DOWN.key) {
                    next(1);
                    return;
                }

                
                if (e.key === KBD.ARROW_UP.key) {
                    prev(1);
                    return;
                }
                


                if (e.key === KBD.ENTER.key) {
                    if(selected.active){
                        callback(selected);
                    } else {
                        //showError({error : "Not implemented yet."})
                    }
                
                    return;
                }

                if (e.key === "Backspace" && search.length > 0) {
                    
                    srch?.current.focus();
                    setSearch(search.slice(0, -1));
                    return;
                }
                const regex = /^[a-z0-9 ]$/i;
                if (regex.test(e.key) && e.key.length === 1) {
                    srch?.current.focus();
                    setSearch(search + e.key);
                }
            }
        },
    ];

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [nav, search])

    const next = (_rows = 1) => {

        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");
        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                onRowClick={(item, event, index) => { setSelected(item) }}
                onRowDoubleClick={(item) => {callback(item)}}
                next={next}
                prev={prev}
                scrollbar={true}
                align={align}
                row_key={row_key}
                current={selected}
                data={data}
                columns={columns}
                width={960}
                loading={false}
                offset={430}
                route={route}
            />
        </>
    )
}